import pink from '@material-ui/core/colors/pink';

export default {
  primary: "#343A40",
  appName: "#fff",
  sideBar: "#343A40",
  appBar: "#fff",
  list: pink[700],
  divider: pink[300],
  floatinbBtnBgColor: "#fff"
}